import React from 'react'
import { useQuery } from 'react-query';
import { getShippingRecords } from '../../api/ship';
import { Button, Table } from 'antd';

const SHIPMENT_STATUS = {
  "pending": "Pending",
  "shipped": "Shpped",
  "in_transit": "In Transit",
  "delivered": "Delivered",
  "need_attention": "Need Attention",
  "awaiting_payment": "Awaiting Payment",
  "cancel": "Canceled",
}

const columns = [
  {
    title: 'Tracking ID',
    dataIndex: '_id',
    key: '_id',
  },
  {
    title: 'Order date',
    dataIndex: 'createdAt',
    key: 'createdAt',
  },
  {
    title: 'Customer',
    render: (_, values) => (
        <p className='capitalize'>{values?.receiver?.name}</p>
    )
  },
  {
    title: 'Product',
    render: (_, values) => (
        <p>{values?.pkg?.category}</p>
    )
  },
  {
    title: 'Delivery Route',
    render: (_, values) => (
        <p>{values?.pkg?.route}</p>
    )
  },
  {
    title: 'Status',
    render: (_, values) => (
        <p>{SHIPMENT_STATUS[values?.shipmentStatus || 'pending']}</p>
    )
  },
  {
    title: 'Action',
    render: (_, values) => (
        <Button type='primary' onClick={() => window.location.href = `/shipping/details/${values._id}`}>View</Button>
    )
  },
];

const ShippingTable = () => {
  const { data: records } = useQuery("shipping-records", getShippingRecords);

  return (
    <div>
      <Table dataSource={records?.shipments || []} columns={columns} />
    </div>
  )
}

export default ShippingTable
